import { render, staticRenderFns } from "./10_confirmation.vue?vue&type=template&id=46c093e6"
import script from "./10_confirmation.vue?vue&type=script&lang=js"
export * from "./10_confirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports